var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepeat = function SvgRepeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65 5.813h11.625V9.3l4.65-4.65L18.275 0v3.487H4.325v6.976H6.65v-4.65Zm11.625 11.625H6.65V13.95L2 18.6l4.65 4.65v-3.488H20.6v-6.975h-2.325v4.65Z",
    fill: "currentColor"
  })));
};
export default SvgRepeat;